export default {
    index: {
        title: "Trang chủ",
        keywords: "JX3,JX3BOX,công cụ,hướng dẫn,tin tức,cộng đồng",
        description: "Trang chủ JX3BOX: tin tức, cộng đồng và bản tin giang hồ.",
    },
    notice: {
        title: "Trung tâm thông báo",
        keywords: "thông báo,tin tức,cập nhật,sự kiện,đổi thưởng,JX3BOX",
        description: "Trung tâm thông báo: xem thông báo, sự kiện, cập nhật và thông báo đổi thưởng từ JX3BOX.",
        single: {
            title: "Chi tiết thông báo",
            keywords: "chi tiết thông báo,thông báo,tin tức,JX3BOX",
            description: "Chi tiết thông báo: đọc nội dung đầy đủ và xem thông tin cập nhật, thống kê tương tác.",
        },
    },
};
